import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col } from 'react-bootstrap';
import { Input, Select } from 'components';
import getZipCode from 'services/api/zipcode';
import { lettersAndLatinCharactersMask, lettersDotAndSpaceMask, numbersMask }
  from 'util/masks';

export default function StepTwo({ handleSubmit, setFieldValue, values }) {
  const [colonies, setColonies] = useState([]);

  useEffect(() => {
    if (values.postalCode.length === 5) {
      getZipCode(values.postalCode).then((val) => {
        setColonies(val.colonias);
        setFieldValue('city', val.ciudad);
        setFieldValue('state', val.estado);
        setFieldValue('municipality', val.municipio);
      });
    }
  }, [setFieldValue, values.postalCode]);

  return (
    <Form id="address" onSubmit={handleSubmit}>
      <Row>
        <Col xs={12} className="p-0">
          <Input
            name="name"
            label="Nombre*"
            maxLength={100}
            mask={lettersDotAndSpaceMask}
          />
        </Col>
        <Col xs={12} sm={6} className="p-0">
          <Input
            name="street"
            label="Calle*"
            mask={lettersAndLatinCharactersMask}
          />
        </Col>
        <Col xs={12} sm={6} className="p-0">
          <Input
            name="postalCode"
            label="Código postal*"
            maxLength={5}
            mask={numbersMask}
          />
        </Col>
        <Col xs={12} sm={6} className="p-0">
          <Input name="state" label="Estado*" disabled />
        </Col>
        <Col xs={12} sm={6} className="p-0">
          <Input name="city" label="Ciudad*" maxLength={100} disabled />
        </Col>
        <Col xs={12} className="p-0">
          <Input
            name="municipality"
            label="Alcaldía o Municipio*"
            maxLength={100}
            disabled
          />
        </Col>
        <Col xs={12} className="p-0">
          <Select
            name="colony"
            label="Colonia*"
            options={colonies.map((colony) => ({
              label: colony,
              value: colony
            }))}
          />
        </Col>
        <Col xs={12} sm={6} className="p-0">
          <Input
            name="exteriorNumber"
            label="No. Exterior*"
            maxLength={100}
            mask={lettersAndLatinCharactersMask}
          />
        </Col>
        <Col xs={12} sm={6} className="p-0">
          <Input
            name="interiorNumber"
            label="No. Interior"
            mask={lettersAndLatinCharactersMask}
          />
        </Col>
      </Row>
    </Form>
  );
}

StepTwo.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.shape({
    name: PropTypes.string,
    street: PropTypes.string,
    postalCode: PropTypes.string,
    state: PropTypes.string,
    city: PropTypes.string,
    municipality: PropTypes.string,
    colony: PropTypes.string,
    exteriorNumber: PropTypes.string,
    interiorNumber: PropTypes.string
  }).isRequired
};
